const tool = {
  id: 14,
  link: "lutning",
  icon: "Slope",
  title: "Lutning",
  content: <>Räknar ut lutningen från höjdskillnad och längd.</>,
};

export default tool;
